export const tokens = {
  colors: {
    main: '#F386A3',
    theme: {
      flower: {
        color1: '#F386A3',
        color2: '#FEF3F6',
        color3: '#F5C2CB',
        linerGradient:
          'linear-gradient(90.07deg, #F386A3 0.28%, #FFFFFF 17.43%)',
      },
      sun: {
        color1: '#E9D11C',
        color2: '#FCFAEF',
        color3: '#E1D15C',
        linerGradient:
          'linear-gradient(90.07deg, #E9D11C 0.28%, #FFFFFF 17.43%)',
      },
      pearl: {
        color1: '#CDC0A2',
        color2: '#FCFBFA',
        color3: '#E3DCCB',
        linerGradient:
          'linear-gradient(90.07deg, #CDC0A2 0.28%, #FFFFFF 17.43%)',
      },
      herb: {
        color1: '#B78DE3',
        color2: '#F9F6FC',
        color3: '#C0A6DE',
        linerGradient:
          'linear-gradient(90.07deg, #B78DE3 0.28%, #FFFFFF 17.43%)',
      },
      ocean: {
        color1: '#6DCACA',
        color2: '#F5FBFB',
        color3: '#99D9D9',
        linerGradient:
          'linear-gradient(90.07deg, #6DCACA 0.28%, #FFFFFF 17.43%)',
      },
      oriental: {
        color1: '#F5A57A',
        color2: '#FEFAF8',
        color3: '#F5A57A',
        linerGradient:
          'linear-gradient(90.07deg, #F5A57A 0.28%, #FFFFFF 17.43%)',
      },
      moon: {
        color1: '#89979F',
        color2: '#FAFBFB',
        color3: '#89979F',
        linerGradient:
          'linear-gradient(90.07deg, #89979F 0.28%, #FFFFFF 17.43%)',
      },
      light: {
        color1: '#E5E0D0',
        color2: '#FCFBF9',
        color3: '#E5E0D0',
        linerGradient:
          'linear-gradient(90.07deg, #E5E0D0 0.28%, #FFFFFF 17.43%)',
      },
      other: {
        color1: '#827B7C',
        color2: '#F7F6F6',
        color3: '#827B7C',
        linerGradient:
          'linear-gradient(90.07deg, #827B7C 0.28%, #FFFFFF 17.43%)',
      },
    },
    progress: {
      toolChipColor: '#F386A3',
      dotColor: '#B9B9B9',
    },
    text: {
      main: '#827B7C',
    },
  },
  size: {
    progressHeight: '50px',
  },
};
